import React from 'react';
import { useAuth } from '../contexts/AuthContext';
import { toValidObjectIdString } from '../utils/security';
import CariHesaplarV2Page from './CariHesaplarV2Page';

/**
 * Teknik servis paneli: Kullanıcının kendi teknik servisine ait cari hesabını gösterir.
 */
const TechServiceCariHesaplarPage = () => {
  const { user } = useAuth();
  const ts = user?.techService;
  const tsId = (ts && (typeof ts === 'object' && ts._id ? ts._id : typeof ts === 'string' ? ts : null)) || user?.techServiceId;
  const forceTeknikServisId = toValidObjectIdString(tsId) || (typeof tsId === 'string' && /^[0-9a-fA-F]{24}$/.test(tsId) ? tsId : null);

  if (!forceTeknikServisId) {
    return (
      <main className="main-content">
        <div style={{ padding: '40px', textAlign: 'center', color: 'var(--text-gray)' }}>
          Teknik servis bilgisi bulunamadı.
        </div>
      </main>
    );
  }

  return <CariHesaplarV2Page forceTeknikServisId={forceTeknikServisId} singleMode />;
};

export default TechServiceCariHesaplarPage;
